import { Component, Input, OnInit, Output, EventEmitter, Injector } from '@angular/core';
import { profileSpecialtiesI } from 'app/core/interfaces/layout';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { Practitioner } from 'app/core/interfaces/practitioner';
import { Practitionerrole } from 'app/core/interfaces/practitionerrole';
import { PractitionerroleService } from 'app/core/http/services/practitionerrole.service';
import { Specialty } from 'app/core/interfaces/specialty';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-practitioner-practitionerrole-by-form',
  templateUrl: './practitionerrole-form.component.html',
  styleUrls: ['./practitionerrole-form.component.scss'],
})
export class PractitionerPractitionerroleFormComponent extends BaseComponent implements OnInit {
  @Output() onUpdatePractitionerRole = new EventEmitter<any>();

  @Input() practitioner_id : string = ""
  @Input() practitioner !: Practitioner
  @Input() practitionerrole: Practitionerrole = <Practitionerrole>{};
  @Input() mode = 'CREATE';
  @Input() actor: string = '';
  @Input() public specialties: Specialty[] = [];

  trackByIndex = (_: number, __: Specialty) => _;

  public ufs: string[] = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO',
  ];
  public titleSpecialties = 'Especialidades';

  private practitionerroleId: string | number | undefined;
  public isSaving = false;
  public specialtyTuss: any[]= []

  constructor(private practitionerroleService: PractitionerroleService, private injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.createOrUpdate();
  }

  allowLettersKeydown(e: KeyboardEvent) {
    if (this.isControlKey(e)) return;
    const k = e.key;
    if (!/^[a-zA-ZÀ-ÿ\s-]$/.test(k)) e.preventDefault();
  }

  allowOnlyLetters(event: KeyboardEvent): void {
    const inputChar = event.key;
    if (!/^[a-zA-ZÀ-ÿ\s]$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  allowNumbersKeydown(e: KeyboardEvent) {
    if (this.isControlKey(e)) return;
    const k = e.key;
    if (!/^\d$/.test(k)) e.preventDefault();
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const inputChar = event.key;
    if (!/^\d$/.test(inputChar)) {
      event.preventDefault();
    }
  }

  onPasteNumbers(event: ClipboardEvent): void {
    const text = event.clipboardData?.getData('text') ?? '';
    if (!/^\d+$/.test(text)) event.preventDefault();
  }

  onPasteLetters(event: ClipboardEvent): void {
    const text = event.clipboardData?.getData('text') ?? '';
    if (!/^[A-Za-zÀ-Üà-ü\s-]+$/.test(text)) event.preventDefault();
  }

  private isControlKey(e: KeyboardEvent) {
    return ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key) || e.ctrlKey || e.metaKey;
  }

  isFormValid(): boolean {
    if (!this.specialties || this.specialties.length === 0) return false;
    return this.specialties.every((s) => !!s.value && s.value.trim().length >= 3 && !!s.crm && /^\d{5,6}$/.test(String(s.crm)) && !!s.uf);
  }

  private getPractitionerSpecialties() {
    
    this.practitionerroleService.findPractitionerByPractitionerroleId(this.practitioner.practitioner_id).subscribe({
      next: (practitionerrole: Practitionerrole[]) => {
        this.practitionerrole = practitionerrole[0];
        this.practitionerroleId = this.practitionerrole.practitionerrole_id;
        this.specialties = this.practitionerrole.specialty;
        this.mode = 'UPDATE';

        this.onUpdatePractitionerRole.emit(practitionerrole)
      },
      error: (err) => {
        this.mode = 'CREATE';
      },
    });
  }


  addSpecialties() {
    if (!this.specialties) {
      this.specialties = [];
    }
    this.specialties.unshift({
      value: '',
      crm: '',
      uf: '',
    });
  }

  getTussBYPrefix(prefix: string) {
  
  
      if (prefix.length < 2) return
  
      let params = new HttpParams()
      params = params.set("prefix", prefix)
      params = params.set("limit", 20)
  
      this.practitionerroleService.getTussByPrefix(params)
        .subscribe({
          next: (tuss: any) => {
            this.specialtyTuss = tuss?.items ?? []
            this.loading = true
          },
          error: (error: HttpErrorResponse) => {
            console.error("Falha ao buscar error")
  
            this.specialtyTuss = []
            this.loading = true
          }
        })
  
    }

  create() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.isSaving = true;

    const organization = this.getUserLogged()
    const practitioner_id = this.practitioner.practitioner_id

    const body = {
      practitioner_id: practitioner_id,
      active: true,
      specialty: this.specialties,
      created_by_organization: {
        organization_id: organization.id,
        organization_name: organization.name
      },

    };


    this.practitionerroleService.createByOrganization(practitioner_id, organization.id, body).subscribe({
      next: (practitionerRole: any) => {
        this.practitionerrole = practitionerRole;
        this.showSuccessMessage = true;
        this.isSaving = false;
        
        this.onUpdatePractitionerRole.emit(practitionerRole)

        setTimeout(() => {
            this.router.navigate(
              ['organization-new/especialistas'],
              { queryParams: { tab: 'qualificacao', 'closeQualification': true } }
            );
            this.loading = false;
        }, 500);

        


      },
      error: (err) => {
        this.showErrorMessage = true;
        this.isSaving = false;
        console.log(err);
      },
    });
  }

  removeSpecialty(index: number) {
    this.specialties.splice(index, 1);
  }

  save() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.isSaving = true;

    this.practitionerrole.practitioner_id = this.practitioner.practitioner_id;

    const practitionerroleFormValues = {
      ...this.practitionerrole,
      specialty: this.specialties,
    };
  
    const organization_id = this.getUserLogged().id
    const practionerRoleId = this.practitionerroleId

    this.practitionerroleService.updateByOrganization(this.practitionerroleId, organization_id, practitionerroleFormValues).subscribe({
      next: (practitionerRole: any) => {
        this.practitionerrole = practitionerRole;
        this.showSuccessMessage = true;
        this.isSaving = false;

        this.onUpdatePractitionerRole.emit(practitionerRole)

      },
      error: (err) => {
        this.showErrorMessage = true;
        this.isSaving = false;
        console.log(err);
      },
    });
  }

  createOrUpdate() {
    this.getPractitionerSpecialties();
  }

  onPasteName(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const validNameRegex = /^[A-Za-zÀ-Üà-ü\s]+$/;
    if (!validNameRegex.test(clipboardData)) {
      event.preventDefault();
    }
  }
}
